import {_actions} from './action-types'
import {_mutations} from './mutation-types'
import RulesService from '@/api/rules'
import { getNamespacesAvailableFilterCriteria, getNewComponentsOnlyAvailableFilterCriteria, getPurposeAvailableFilterCriteria } from '@/pages/rules/utils/componentsFilterUtils'

export const actions = {
  async [_actions.GET_COMPONENTS] ({commit}, { projectId, effectiveDateId }) {
    commit(_mutations.START_LOADING_COMPONENTS)
    try {
      let components = await RulesService.getComponentsByEffectiveDate(projectId, effectiveDateId)
      commit(_mutations.SET_COMPONENTS, components)
    } catch (error) {
      commit(_mutations.SET_ERROR_LOADING_COMPONENTS, error)
    }
    commit(_mutations.STOP_LOADING_COMPONENTS)
  },
  async [_actions.BUILD_AVAILABLE_FILTER_CRITERIA] ({commit}, { packageId, projectId, effectiveDateId }) {
    commit(_mutations.RESET_AVAILABLE_FILTER_CRITERIA)
    try {
      const [namespaces, purposes, currentVersion] = await Promise.all([
        RulesService.getNamespaces(packageId),
        RulesService.getPurposes(),
        RulesService.getVersionByEffectiveDateId(projectId, effectiveDateId)
      ])
      commit(_mutations.SET_AVAILABLE_FILTER_CRITERIA, [...getNamespacesAvailableFilterCriteria(namespaces),
        ...getNewComponentsOnlyAvailableFilterCriteria(currentVersion),
        ...getPurposeAvailableFilterCriteria(purposes)
      ])
    } catch (error) {
      commit(_mutations.SET_ERROR_BUILDING_AVAILABLE_FILTER_CRITERIA, error)
    }
  }
}
